/* scroll to parter card */
const container = document.querySelector(".partners-page__cards-container");

document
  .querySelectorAll(".partners-page__category-container")
  .forEach((item) => {
    item.addEventListener("click", function () {
      const partnerId = this.getAttribute("data-partner-id");
      const target = document.getElementById(partnerId);

      if (!target || !container) return;

      let offset = 80;

      if (window.innerWidth <= 640) {
        offset = 960;
      }

      container.scrollTo({
        top: target.offsetTop - offset,
        behavior: "smooth",
      });
    });
  });

/* category dropdown for mobile */

const categories_container = document.querySelector(
  ".partners-page__categories"
);

if (categories_container) {
  const categories = categories_container.querySelectorAll("li");

  categories_container.addEventListener("click", function () {
    const is_open = categories_container.getAttribute("open");

    if (is_open == null) {
      categories_container.setAttribute("open", "");
    }
  });

  categories.forEach((item) => {
    item.addEventListener("click", function (e) {
      const is_open = categories_container.getAttribute("open");

      if (is_open != null) {
        e.stopPropagation();

        categories.forEach((categoy) => {
          categoy.removeAttribute("selected");
          item.setAttribute("selected", "");
        });
        categories_container.removeAttribute("open");
      }
    });
  });
}
